<style>
  ::ng-deep app-selectbox label { position: absolute; top: -18px;}
</style>

<div
  [className]="user == undefined ? 'width-constrained-some' : ''"
  style="margin-bottom: 20px"
>
  <div [hidden]="user == undefined" style="display: flex; align-items: start; gap: 20px; margin: 20px auto; justify-content: center;">
    <input
      type="button"
      value="Back"
      class="cancel"
      (click)="btnCancel_click()"
    />
    <input
      type="button"
      value="Impersonate User"
      class="btn-core toolbar-button"
      style="height: 37px; margin: 0px; width: 100%;"
      (click)="btnImpersonateUser_click()"
    />
  </div>
  <div style="display: flex; gap: 20px">
    <div class ="cpo-section-container paddedContent containerMargins">
      <app-user-form
        #userForm
        style="margin-bottom: 20px; display: block;"
        [isNew]="this._currentMode == FormMode.New"
        [enableEditing]="true"
        [initialMode]="_currentMode"
        [enableRoleSelection]="enableRoleSelection"
        [enableSaving]="true"
        [enableSelectExistingUser]="enableSelectExistingUser"
        [user]="user"
        [merchantId]="merchantId"
        (cancelled)="btnCancelEditInfo_click()"
        (created)="(created)"
      ></app-user-form>
      <h2 class="cpo-section-title" style="margin:0px !important; padding: 0px !important;">Associated Businesses</h2>
        
        <app-filterable-table #merchantTable
          [hideTop]="true"
          [hidden]="user == undefined"
          [emptyMessage]="'No associated businesses found for this user.'"
          style="display: block; margin: 20px 0;"
          [tableView]="merchantsTableView"
        ></app-filterable-table>

        <div
          [hidden]="user == undefined"
          style="
            margin: 20px 0px;
            padding-top: 20px;
            border-top: 1px solid #dddddd;
            border-bottom: 1px solid #dddddd;
          "
        >
          @if (this.user?.id) {
            <div style="display: flex; align-items: start; gap: 10px; justify-content: space-between;">
              <h2 class="cpo-section-title">Account {{ this.user?.isDisabled ? 'Disabled' : 'Enabled' }}</h2>
              @if (this.enableEditing) {
                <div>
                  <span class="cpo-edit-link" [style.color]="this.user?.isDisabled ? 'var(--green-400)' : 'var(--archive-red)'" (click)="this.user?.isDisabled ? btnEnable_click() : btnDisable_click()">{{ this.user?.isDisabled ? 'Enable account' : 'Disable account' }}</span>
                </div>
              }
            </div>
            <div style="display: flex; align-items: start; gap: 10px; justify-content: space-between;">
              <h2 class="cpo-section-title">{{ this.user?.requiresPasswordReset ? 'Password Reset Required On Login' : 'Password Reset Not Required' }}</h2>
              @if (this.enableEditing) {
                <div *ngIf="!this.user?.requiresPasswordReset">
                  <span class="cpo-edit-link" (click)="btnResetPassword_click()">Require password reset on login</span>
                </div>
              }
            </div>
          }
        </div>

        <div [hidden]="user == undefined">
          <div style="display: flex; flex-direction: column; align-items: start; gap: 10px;">
            <h2 class="cpo-section-title" style="margin: 0px !important; padding: 0px !important;">Current role</h2>
            <div class="cpo-subheading">{{ (roleOptions | findById:user?.originalRole)?.name }}</div>
          </div>
        </div>

        <div [hidden]="user == undefined" style="display: flex; flex-direction: column; gap: 20px">
          <div style="display: flex; flex-direction: column; align-items: start; gap: 10px;">
            <p [hidden]="user == undefined" class="green-text" style="margin: 20px 0 30px;">
              Revert this user to the default permissions of a role. Note that
              if this user currently has custom permissions, you will have to
              reselect them after this change.
            </p>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px; width: 100%;">
              <app-selectbox [label]="'Role'" style="margin: 0px !important; padding: 0px !important; position: relative;"
                [(ngModel)]="selectedRole"
                [disabled]="_currentMode == FormMode.View"
                [options]="roleOptions"
              ></app-selectbox>
              <input
                type="button"
                value="Change Role"
                class="primary"
                style="padding: 6px;"
                [disabled]="selectedRole == user?.originalRole"
                (click)="btnChangeRole_click()"
              />
            </div>
              
          </div>
            
          <div>
            <p [hidden]="user == undefined" class="green-text" style="margin: 20px 0 40px;">
              Change this user's roles to match those of another user. Note that
              if this user currently has custom permissions, you will have to
              reselect them after this change.
            </p>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px; width: 100%;">
              <app-auto-fill-input style="margin: 0px !important;"
                [optionsFunction]="getUsers"
                [label]="'Source User'"
                [(ngModel)]="sourceRolesUser"
              ></app-auto-fill-input>
              <input
                type="button"
                value="Copy roles"
                class="primary"
                style="padding: 6px;"
                [disabled]="!sourceRolesUser"
                (click)="btnCopyUserRoles_click()"
              />
            </div>
          </div>
        </div>


      
    </div>

    <div class ="cpo-section-container paddedContent containerMargins" style="flex: 2; background: var(--green-100);">
      <div style="display: flex;align-items: start; gap: 20px; justify-content: space-between;">
        <h2 class="cpo-section-title">
          Custom Permissions
        </h2>
        <div [hidden]="!enableEditing || userPermsViewMode != FormMode.View">
          <span class="cpo-edit-link" (click)="userPermsViewMode = formMode.Edit">Edit</span>
        </div>
      </div>
      <div [hidden]="userPermsViewMode != FormMode.View" style="margin-bottom: -20px;"  class="cpo-pod-list">
          @for (category of accessCategories; track category) {
            <div [hidden]="!categoryHasCheckedItems(category)" style="display:flex;flex-direction:column;">
              <div class="cpo-subheadeing">{{ (category || 'Unknown Category')| titlecase }}</div>
              <ul style="margin: 0px 0px 20px">
                @for (item of allAccessBitsToCheck; track item; let i = $index; let first = $first) {
                  <li *ngIf="item.category == category" [hidden]="!getChecked(item.name, item.category)">
                    {{ item.friendlyName || item.name || 'Unknown' }}
                  </li>
                }
              </ul>
            </div>
          }     
      </div>

      <div [hidden]="userPermsViewMode != FormMode.Edit" style="margin-bottom: -20px;"  class="cpo-pod-list">
        <!--
        Only show checkboxes that can be configured by the current user.
        1) if merchant, show just configurable checkboxes
        2) otherwise, show all
        -->
        @for (category of accessCategories; track category) {
          <div style="display:flex;flex-direction:column;" class="cpo-pod-list">
            <div class="cpo-subheadeing">{{ (category || 'Unknown Category')| titlecase }}</div>
            <ul style="margin: 0px 0px 20px; padding: 0px; list-style: none;">
              @for (item of allAccessBitsToCheck; track item; let i = $index; let first = $first) {
                <li *ngIf="item.category == category">
                  <input
                    type="checkbox"
                    class="namespace"
                    value="{{ item.name }}"
                    [checked]="getChecked(item.name, item.category)"
                    (click)="toggleAccess($event, item.name)"
                  />
                  {{ item.friendlyName || item.name || 'Unknown' }}
                </li>
              }
            </ul>
          </div>
        }     

        <input
          type="button"
          value="Back"
          class="cancel"
          (click)="userPermsViewMode = formMode.View"
          />
        <input
          type="button"
          value="Save Permissions Changes"
          class="primary"
          style="margin-bottom:20px"
          (click)="btnSaveCustomPerms_click()"
        />
        
      </div>

    </div>
  </div>
</div>
